import GradeIcon from "./GradeIcon";

const RiskItem = ({ riskKey, details, scoreData }) => {
  // Function to convert numeric value to descriptive label
  const getLikelihoodLabel = (value) => {
    switch(value) {
      case 0: return "Negligible";
      case 1: return "Very Low";
      case 2: return "Low";
      case 3: return "Moderate";
      case 4: return "High";
      case 5: return "Very High";
      default: return "Unknown";
    }
  };

  const getImpactLabel = (value) => {
    switch(value) {
      case 0: return "Negligible";
      case 1: return "Very Low";
      case 2: return "Low";
      case 3: return "Moderate";
      case 4: return "High";
      case 5: return "Very High";
      default: return "Unknown";
    }
  };

  // Function to get color based on severity
  const getSeverityColor = (value) => {
    if (value <= 1) return "text-green-600";
    if (value <= 2) return "text-yellow-600";
    if (value <= 3) return "text-orange-600";
    return "text-red-600";
  };

  return (
    <li key={riskKey} className="mb-3 p-3 bg-gray-50 rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <strong className="capitalize text-lg text-gray-800">
          {riskKey.replace(/_/g, " ")}
        </strong>
        <div className="flex items-center">
          <GradeIcon grade={scoreData?.grade} />
          <span className="font-bold text-lg ml-1">{scoreData?.score}</span>
        </div>
      </div>
      
      <div className="flex items-center space-x-6 mb-2 text-sm">
        <div className="flex items-center">
          <span className="font-medium text-gray-700 mr-2">Likelihood:</span>
          <span className={`font-semibold px-2 py-1 rounded ${getSeverityColor(scoreData?.rawLikelihood)} bg-white border`}>
            {getLikelihoodLabel(scoreData?.rawLikelihood)}
          </span>
          <span className="text-gray-500 ml-1">({scoreData?.rawLikelihood}/5)</span>
        </div>
        
        <div className="flex items-center">
          <span className="font-medium text-gray-700 mr-2">Impact:</span>
          <span className={`font-semibold px-2 py-1 rounded ${getSeverityColor(scoreData?.impact)} bg-white border`}>
            {getImpactLabel(scoreData?.impact)}
          </span>
          <span className="text-gray-500 ml-1">({scoreData?.impact}/5)</span>
        </div>
      </div>
      
      <ul className="text-sm text-gray-600 list-disc pl-5 mt-2">
        {details.reason.map((reason, index) => (
          <li key={index}>{reason}</li>
        ))}
      </ul>
    </li>
  );
};

export default RiskItem;
